import { Card, Col, Row } from "antd";
import { Link } from "react-router-dom";
import type { Audit } from "../../../types/audits";
import type { Constat } from "../../../types/constats";
import dayjs from "dayjs";
import spacing from "../../../components/ui/spacingConfig";

type Props = {
  constatData: Constat | undefined;
  audit?: Audit;
  className?: string;
};

const CardDatePlaceConstat: React.FC<Props> = ({
  constatData,
  audit,
  className,
}) => {
  return (
    <Card title="Date et lieu" bordered={false} className={className}>
      <Row>
        <Col span={spacing.xs}>
          <p className="text-light-grey">Audit</p>
        </Col>
        <Col span={spacing.xs}>
          {audit ? (
            <Link to={`/audits/${audit.id}`} className="text-light-blue">
              {audit.title}
            </Link>
          ) : (
            <p className="text-light-blue">
              {constatData?.audit ? constatData.audit.title : ""}
            </p>
          )}
        </Col>
      </Row>
      <Row>
        <Col span={spacing.xs}>
          <p className="text-light-grey">Site</p>
        </Col>
        <Col span={spacing.xs}>
          <p className="text-light-blue">{constatData?.site?.name}</p>
        </Col>
      </Row>
      <Row>
        <Col span={spacing.xs}>
          <p className="text-light-grey">PrÃ©cision</p>
        </Col>
        <Col span={spacing.xs}>
          <p className="text-light-blue">{constatData?.localisation}</p>
        </Col>
      </Row>
      <Row>
        <Col span={spacing.xs}>
          <p className="text-light-grey">Date de la dÃ©claration</p>
        </Col>
        <Col span={spacing.xs}>
          <p>
            {constatData?.dateCreated
              ? dayjs(constatData.dateCreated).format("DD/MM/YYYY")
              : ""}
          </p>
        </Col>
      </Row>
      <Row>
        <Col span={spacing.xs}>
          <p className="text-light-grey">Date de l'Ã©vÃ©nement</p>
        </Col>
        <Col span={spacing.xs}>
          <p>
            {constatData?.dateEvt
              ? dayjs(constatData.dateEvt).format("DD/MM/YYYY")
              : ""}
          </p>
        </Col>
      </Row>
      <Row>
        <Col span={spacing.xs}>
          <p className="text-light-grey">Date de modification</p>
        </Col>
        <Col span={spacing.xs}>
          <p>
            {constatData?.dateLastModif
              ? dayjs(constatData.dateLastModif).format("DD/MM/YYYY")
              : ""}
          </p>
        </Col>
      </Row>
    </Card>
  );
};

export default CardDatePlaceConstat;
